import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const isLocalhostEnv = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
if (isLocalhostEnv) {
  localStorage.setItem('apiURL', 'http://127.0.0.1:8000');
}

const originalOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function(method, url, ...rest) {
  if (typeof url === 'string' && isLocalhostEnv && url.includes('https://api.tecnologiaasap.com.br')) {
    url = url.replace('https://api.tecnologiaasap.com.br', 'http://127.0.0.1:8000');
  }
  (this as any)._url = url;
  return originalOpen.apply(this, [method, url, ...rest] as any);
};

const originalSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function(body) {
  const url = (this as any)._url;
  if (url && typeof url === 'string') {
    const isOurApi = !url.startsWith('http') || url.includes((environment as any).apiURL) || url.includes((environment as any).baseURL) || url.includes('hmgasap.com.br') || url.includes('tecnologiaasap.com.br') || url.includes('127.0.0.1:8000') || url.includes('localhost:8000');
    const isThirdParty = url.includes('viacep') || url.includes('filestack') || url.includes('firebase') || url.includes('googleapis');
    if (isOurApi && !isThirdParty && url.includes('/api/')) {
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      if (!isLocalhost) {
        this.withCredentials = true;
      }
      this.setRequestHeader('X-Device-Context', 'asap_authorized_access');
    }
  }
  return originalSend.apply(this, arguments as any);
};

const originalFetch = window.fetch;
window.fetch = function() {
  let [resource, config] = arguments;
  if (typeof resource === 'string') {
    if (isLocalhostEnv && resource.includes('https://api.tecnologiaasap.com.br')) {
      resource = resource.replace('https://api.tecnologiaasap.com.br', 'http://127.0.0.1:8000');
      arguments[0] = resource;
    }
    const isOurApi = !resource.startsWith('http') || resource.includes((environment as any).apiURL) || resource.includes((environment as any).baseURL) || resource.includes('hmgasap.com.br') || resource.includes('tecnologiaasap.com.br') || resource.includes('127.0.0.1:8000') || resource.includes('localhost:8000');
    const isThirdParty = resource.includes('viacep') || resource.includes('filestack') || resource.includes('firebase') || resource.includes('googleapis');
    if (isOurApi && !isThirdParty && resource.includes('/api/')) {
      config = config || {};
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      if (!isLocalhost) {
        config.credentials = 'include';
      }
      config.headers = config.headers || {};
      config.headers['X-Device-Context'] = 'asap_authorized_access';
      arguments[1] = config;
    }
  }
  return originalFetch.apply(this, arguments as any);
};

const apiUrl = (environment as any).apiURL || (environment as any).baseURL || '';



platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
